import { Children, type HTMLAttributes } from "react";

import { cn } from "@/lib/helpers/cn";

export function ReminderContainer({ children, ...props }: HTMLAttributes<HTMLDivElement>) {
  if (Children.toArray(children).length === 0) return null;

  return (
    <section
      className={cn("tw:flex tw:flex-col tw:gap-5", "tw:not-[:empty]:mb-6 tw:empty:hidden")}
      {...props}
    >
      {children}
    </section>
  );
}
